module.exports = __webpack_public_path__ + "static/media/out.f66a2ecf.svg";